import axios from "axios";

export const state = {
    membershipfees: [],
};

export const getters = {
    membershipfees: state => state.membershipfees,
};

export const mutations = {
    setMembershipFees(state, newValue) {
        state.membershipfees = newValue
    },
};

export const actions = {
    async fetchMembershipFees({ commit }) {
        await axios.get('/membershipfees').then(res => {
            commit('setMembershipFees', res.data.membershipfees)
        })
    },
    async filterMembershipFees({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filtermembershipfees";
        await axios.post(url, formData).then((response) => {
            commit('setMembershipFees', response.data.membershipfees)
        })
    },
};
